<template>
  <div class="text-center">
    <v-card
      min-width="350"
      max-width="500"
      :class="{ 'elevation-20': !$vuetify.breakpoint.xsOnly }"
      color="#006666"
      dark
      class="rounded-lg"
    >
      <v-card-text>
        <v-flex>
          <v-flex>
            <img height="100" src="@/assets/images/logo.png" />
          </v-flex>
        </v-flex>
        <div class="text-h6 mb-2">Set New Password</div>
        <v-text-field
          v-model="password"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
          @click:append="showPassword = !showPassword"
          outlined
          dense
          label="New Password"
        />
        <v-text-field
          v-model="confirmPassword"
          :type="showConfirmPassword ? 'text' : 'password'"
          :append-icon="showConfirmPassword ? 'visibility_off' : 'visibility'"
          @click:append="showConfirmPassword = !showConfirmPassword"
          outlined
          dense
          label="Confirm Password"
        />
        <v-btn block color="white" class="mt-4" @click="submit" outlined
          >Save Password</v-btn
        >
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import userService from "@/modules/User/service.js"

export default {
  data() {
    return {
      password: "",
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false
    };
  },
  methods: {
    submit() {
      console.log("Resetting password with token:", this.password, this.confirmPassword);
      if (this.password !== this.confirmPassword) {
        this.$swal("Mismatch", "Passwords do not match.", "error");
        return;
      }
      console.log("Resetting password with token:", this.$route.query);
      userService
        .resetPassword({
          resetToken: this.$route.query.token,
          password: this.password,
        })
        .then(() => {
          this.$swal("Success", "Your password has been updated.", "success");
          this.$router.push("/login");
        })
        .catch((error) => {
          console.error("Error resetting password:", error);
          this.$swal("Error", "Something went wrong.", "error");
        });
    },
  },
};
</script>